import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import Lottie from 'lottie-react';
import {
  ArrowRight,
  CheckCircle2,
  Zap,
  Shield,
  BarChart3,
  Users,
  FileText,
  Brain,
  Target,
  Sparkles,
  TrendingUp,
  Play,
  ChevronDown,
  Mail,
  Phone,
  MapPin,
  Send,
  Star,
  Quote
} from 'lucide-react';

// Animation Lottie pour l'email envoyé
const emailSentAnimation = {
  "v": "5.7.4",
  "fr": 30,
  "ip": 0,
  "op": 60,
  "w": 200,
  "h": 200,
  "nm": "Email Sent",
  "ddd": 0,
  "assets": [],
  "layers": [
    {
      "ddd": 0,
      "ind": 1,
      "ty": 4,
      "nm": "Checkmark",
      "sr": 1,
      "ks": {
        "o": { "a": 1, "k": [{ "t": 20, "s": [0] }, { "t": 30, "s": [100] }] },
        "r": { "a": 0, "k": 0 },
        "p": { "a": 0, "k": [100, 100, 0] },
        "a": { "a": 0, "k": [0, 0, 0] },
        "s": { "a": 1, "k": [{ "t": 20, "s": [0, 0, 100] }, { "t": 35, "s": [100, 100, 100] }] }
      },
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ty": "sh",
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": false,
                  "v": [[-25, 0], [-8, 17], [25, -17]],
                  "i": [[0, 0], [0, 0], [0, 0]],
                  "o": [[0, 0], [0, 0], [0, 0]]
                }
              }
            },
            {
              "ty": "st",
              "c": { "a": 0, "k": [0.235, 0.729, 0.329, 1] },
              "o": { "a": 0, "k": 100 },
              "w": { "a": 0, "k": 8 },
              "lc": 2,
              "lj": 2
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 5] },
              "a": { "a": 0, "k": [0, 0] },
              "s": { "a": 0, "k": [100, 100] },
              "r": { "a": 0, "k": 0 },
              "o": { "a": 0, "k": 100 }
            }
          ]
        }
      ]
    },
    {
      "ddd": 0,
      "ind": 2,
      "ty": 4,
      "nm": "Envelope",
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100 },
        "r": { "a": 0, "k": 0 },
        "p": { "a": 1, "k": [{ "t": 0, "s": [100, 120, 0] }, { "t": 20, "s": [100, 90, 0] }] },
        "a": { "a": 0, "k": [0, 0, 0] },
        "s": { "a": 0, "k": [100, 100, 100] }
      },
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ty": "rc",
              "d": 1,
              "s": { "a": 0, "k": [80, 50] },
              "p": { "a": 0, "k": [0, 0] },
              "r": { "a": 0, "k": 5 }
            },
            {
              "ty": "st",
              "c": { "a": 0, "k": [0.365, 0.514, 0.906, 1] },
              "o": { "a": 0, "k": 100 },
              "w": { "a": 0, "k": 4 }
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [0.922, 0.941, 0.996, 1] },
              "o": { "a": 0, "k": 100 }
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0] },
              "a": { "a": 0, "k": [0, 0] },
              "s": { "a": 0, "k": [100, 100] },
              "r": { "a": 0, "k": 0 },
              "o": { "a": 0, "k": 100 }
            }
          ]
        },
        {
          "ty": "gr",
          "it": [
            {
              "ty": "sh",
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": false,
                  "v": [[-40, -25], [0, 5], [40, -25]],
                  "i": [[0, 0], [0, 0], [0, 0]],
                  "o": [[0, 0], [0, 0], [0, 0]]
                }
              }
            },
            {
              "ty": "st",
              "c": { "a": 0, "k": [0.365, 0.514, 0.906, 1] },
              "o": { "a": 0, "k": 100 },
              "w": { "a": 0, "k": 4 },
              "lc": 2,
              "lj": 2
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0] },
              "a": { "a": 0, "k": [0, 0] },
              "s": { "a": 0, "k": [100, 100] },
              "r": { "a": 0, "k": 0 },
              "o": { "a": 0, "k": 100 }
            }
          ]
        }
      ]
    },
    {
      "ddd": 0,
      "ind": 3,
      "ty": 4,
      "nm": "Circle",
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100 },
        "r": { "a": 0, "k": 0 },
        "p": { "a": 0, "k": [100, 100, 0] },
        "a": { "a": 0, "k": [0, 0, 0] },
        "s": { "a": 1, "k": [{ "t": 0, "s": [0, 0, 100] }, { "t": 15, "s": [100, 100, 100] }] }
      },
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ty": "el",
              "d": 1,
              "s": { "a": 0, "k": [120, 120] },
              "p": { "a": 0, "k": [0, 0] }
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [0.922, 0.941, 0.996, 1] },
              "o": { "a": 0, "k": 100 }
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0] },
              "a": { "a": 0, "k": [0, 0] },
              "s": { "a": 0, "k": [100, 100] },
              "r": { "a": 0, "k": 0 },
              "o": { "a": 0, "k": 100 }
            }
          ]
        }
      ]
    }
  ]
};

/**
 * Landing Page publique - Orbloom
 * Sections : Hero, Features, Ecosystem, How It Works, Pricing, Testimonials, FAQ, Contact
 */
export default function LandingPage() {
  const navigate = useNavigate();
  const [activeFaq, setActiveFaq] = useState(null);
  const [contactForm, setContactForm] = useState({ name: '', email: '', company: '', message: '' });
  const [contactSubmitted, setContactSubmitted] = useState(false);
  const [contactLoading, setContactLoading] = useState(false);
  const [newsletterEmail, setNewsletterEmail] = useState('');
  const [newsletterLoading, setNewsletterLoading] = useState(false);

  // Fonctionnalités principales
  const features = [
    {
      icon: <Brain className="w-8 h-8" />,
      title: "Analyse RNCP Intelligente",
      description: "Importez vos formations et obtenez une analyse automatique des correspondances avec le référentiel RNCP officiel.",
      color: "from-blue-500 to-blue-600"
    },
    {
      icon: <BarChart3 className="w-8 h-8" />,
      title: "Visualisation Interactive",
      description: "Explorez vos données avec des graphes D3.js interactifs. Filtrez par secteur, niveau, et type de certification.",
      color: "from-purple-500 to-purple-600"
    },
    {
      icon: <Zap className="w-8 h-8" />,
      title: "Fusion Automatique",
      description: "Détectez et fusionnez les compétences en doublon grâce à notre algorithme de similarité avancé.",
      color: "from-orange-500 to-orange-600"
    },
    {
      icon: <FileText className="w-8 h-8" />,
      title: "Import/Export Multi-formats",
      description: "Importez depuis CSV, Excel, JSON. Exportez vos analyses en PDF, CSV ou JSON en un clic.",
      color: "from-green-500 to-green-600"
    },
    {
      icon: <Users className="w-8 h-8" />,
      title: "Collaboration d'Équipe",
      description: "Travaillez à plusieurs avec un système de rôles et permissions granulaires (Admin, Responsable, Collaborateur).",
      color: "from-pink-500 to-pink-600"
    },
    {
      icon: <Shield className="w-8 h-8" />,
      title: "Sécurité & RGPD",
      description: "Données chiffrées AES-256, hébergement France, conformité RGPD totale. Vos données vous appartiennent.",
      color: "from-indigo-500 to-indigo-600"
    }
  ];

  // Écosystème
  const ecosystem = [
    {
      title: "France Compétences",
      description: "Synchronisation automatique avec le répertoire national RNCP",
      logo: "🇫🇷"
    },
    {
      title: "France Travail",
      description: "Intégration des codes ROME et compétences professionnelles",
      logo: "💼"
    },
    {
      title: "Data.gouv.fr",
      description: "Téléchargement automatique des données officielles",
      logo: "📊"
    },
    {
      title: "Qualiopi",
      description: "Conformité avec les exigences du référentiel qualité",
      logo: "✅"
    }
  ];

  // Comment ça fonctionne
  const steps = [
    {
      number: "01",
      title: "Importez vos formations",
      description: "Téléchargez votre catalogue au format CSV, Excel ou JSON. Notre système analyse automatiquement la structure.",
      icon: <FileText className="w-12 h-12" />
    },
    {
      number: "02",
      title: "Analyse automatique",
      description: "L'IA analyse vos formations et les compare au référentiel RNCP officiel pour trouver les meilleures correspondances.",
      icon: <Brain className="w-12 h-12" />
    },
    {
      number: "03",
      title: "Visualisez les résultats",
      description: "Explorez vos données avec des graphes interactifs. Filtrez, triez, et découvrez les synergies.",
      icon: <BarChart3 className="w-12 h-12" />
    },
    {
      number: "04",
      title: "Exportez et partagez",
      description: "Exportez vos analyses en PDF pour vos rapports ou CSV pour vos outils internes. Collaborez avec votre équipe.",
      icon: <Target className="w-12 h-12" />
    }
  ];

  // Témoignages
  const testimonials = [
    {
      name: "Sophie Martin",
      role: "Directrice Pédagogique",
      company: "OF Excellence Formation",
      avatar: "SM",
      rating: 5,
      text: "Orbloom a révolutionné notre façon de gérer notre catalogue de formations. Le temps économisé sur l'analyse RNCP nous permet de nous concentrer sur l'essentiel : la qualité pédagogique."
    },
    {
      name: "Jean Dupont",
      role: "Responsable Qualité",
      company: "Institut de Formation Pro",
      avatar: "JD",
      rating: 5,
      text: "L'analyse automatique et la visualisation interactive sont des atouts majeurs. Nous avons réduit de 70% le temps passé sur les correspondances RNCP."
    },
    {
      name: "Marie Leblanc",
      role: "Coordinatrice",
      company: "Centre de Formation Continue",
      avatar: "ML",
      rating: 5,
      text: "Interface intuitive, résultats fiables, et un support réactif. Exactement ce dont nous avions besoin pour notre certification Qualiopi."
    }
  ];

  // FAQ
  const faqs = [
    {
      question: "Quelle différence entre Starter et Pro ?",
      answer: "Le plan Starter (29€/mois) convient aux organismes avec jusqu'à 50 formations et offre les fonctionnalités essentielles. Le plan Pro (99€/mois) propose des formations illimitées, l'analyse avancée des blocs de compétences, l'export multi-formats, et un support prioritaire."
    },
    {
      question: "Comment sont protégées mes données RNCP ?",
      answer: "Vos données sont chiffrées avec AES-256, hébergées en France (OVH), et nous sommes 100% conformes RGPD. Vous gardez la propriété totale de vos données et pouvez les exporter ou supprimer à tout moment."
    },
    {
      question: "Puis-je changer de plan à tout moment ?",
      answer: "Oui, vous pouvez upgrader ou downgrader à tout moment. Les changements prennent effet immédiatement et sont proratisés."
    },
    {
      question: "Que se passe-t-il si je dépasse ma limite de formations ?",
      answer: "Pour le plan gratuit (0€), vous êtes limité à visualiser et fusionner 2 formations. Au-delà, vous recevrez une notification pour passer à un plan payant. Les plans Starter (50 formations) et Pro (illimité) s'adaptent à vos besoins."
    },
    {
      question: "Proposez-vous des réductions pour les associations ?",
      answer: "Oui ! Les associations à but non lucratif bénéficient d'une réduction de 30% sur tous nos plans. Contactez-nous avec votre justificatif pour en bénéficier."
    },
    {
      question: "L'abonnement annuel me fait économiser combien ?",
      answer: "L'abonnement annuel vous fait économiser 20% par rapport au paiement mensuel. Par exemple, le plan Pro coûte 63€/mois en annuel contre 79€/mois en mensuel, soit une économie de 192€/an."
    }
  ];

  const handleContactSubmit = async (e) => {
    e.preventDefault();
    setContactLoading(true);

    try {
      const response = await fetch(`${import.meta.env.VITE_API_URL}/api/contact`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: contactForm.name,
          email: contactForm.email,
          subject: `[Landing Page] ${contactForm.company || 'Contact'}`,
          message: `Organisme: ${contactForm.company || 'Non renseigné'}\n\n${contactForm.message}`
        })
      });

      if (!response.ok) {
        throw new Error('Erreur lors de l\'envoi');
      }

      setContactSubmitted(true);
      setContactForm({ name: '', email: '', company: '', message: '' });
    } catch (error) {
      console.error('Contact form error:', error);
      toast.error('Erreur lors de l\'envoi du message. Veuillez réessayer.');
    } finally {
      setContactLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-white">
      {/* ============ HEADER PUBLIC ============ */}
      <header className="sticky top-0 z-50 bg-white/90 backdrop-blur-md border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            {/* Logo */}
            <div className="flex items-center">
              <div className="flex items-center gap-2">
                <div className="w-10 h-10 bg-gradient-to-br from-blue-600 to-purple-600 rounded-lg flex items-center justify-center">
                  <Target className="w-6 h-6 text-white" />
                </div>
                <span className="text-xl font-bold text-gray-900">Orbloom</span>
              </div>
            </div>

            {/* Navigation */}
            <nav className="hidden md:flex items-center gap-8">
              <a href="#features" className="text-gray-600 hover:text-gray-900 font-medium transition">Fonctionnalités</a>
              <a href="#how-it-works" className="text-gray-600 hover:text-gray-900 font-medium transition">Comment ça marche</a>
              <a href="#pricing" className="text-gray-600 hover:text-gray-900 font-medium transition">Tarifs</a>
              <a href="#faq" className="text-gray-600 hover:text-gray-900 font-medium transition">FAQ</a>
              <a href="#contact" className="text-gray-600 hover:text-gray-900 font-medium transition">Contact</a>
            </nav>

            {/* CTAs */}
            <div className="flex items-center gap-4">
              <button
                onClick={() => navigate('/login')}
                className="text-gray-600 hover:text-gray-900 font-medium transition"
              >
                Connexion
              </button>
              <button
                onClick={() => navigate('/register')}
                className="bg-gradient-to-r from-blue-600 to-purple-600 text-white px-6 py-2 rounded-lg font-semibold hover:from-blue-700 hover:to-purple-700 transition shadow-md hover:shadow-lg"
              >
                Essai gratuit
              </button>
            </div>
          </div>
        </div>
      </header>

      {/* ============ HERO SECTION ============ */}
      <section className="relative overflow-hidden bg-gradient-to-br from-blue-50 via-white to-purple-50 py-20 lg:py-32">
        {/* Decorative elements */}
        <div className="absolute top-0 left-0 w-96 h-96 bg-blue-400/10 rounded-full filter blur-3xl -translate-x-1/2 -translate-y-1/2"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-purple-400/10 rounded-full filter blur-3xl translate-x-1/2 translate-y-1/2"></div>

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            {/* Left side */}
            <div className="text-center lg:text-left">
              <div className="inline-flex items-center gap-2 px-4 py-2 bg-blue-100 text-blue-700 rounded-full text-sm font-semibold mb-6">
                <Sparkles className="w-4 h-4" />
                Plateforme #1 de pilotage pédagogique RNCP
              </div>

              <h1 className="text-5xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight">
                Pilotez vos formations RNCP avec
                <span className="bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent"> intelligence</span>
              </h1>

              <p className="text-xl text-gray-600 mb-8 max-w-2xl">
                Analysez, visualisez et optimisez vos correspondances RNCP en quelques clics.
                Gagnez <strong>70% de temps</strong> sur vos analyses pédagogiques.
              </p>

              <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start mb-8">
                <button
                  onClick={() => navigate('/register')}
                  className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-xl font-semibold text-lg hover:from-blue-700 hover:to-purple-700 transition shadow-lg hover:shadow-xl"
                >
                  Commencer gratuitement
                  <ArrowRight className="w-5 h-5" />
                </button>
                <a
                  href="https://cal.com/orbloom/demo-30-min"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-white border-2 border-gray-300 text-gray-900 rounded-xl font-semibold text-lg hover:border-blue-500 hover:bg-blue-50 transition shadow-md"
                >
                  <Play className="w-5 h-5" />
                  Demander une démo
                </a>
              </div>

              <div className="flex items-center gap-8 justify-center lg:justify-start text-sm text-gray-600">
                <div className="flex items-center gap-2">
                  <CheckCircle2 className="w-5 h-5 text-green-500" />
                  Gratuit jusqu'à 2 formations
                </div>
                <div className="flex items-center gap-2">
                  <CheckCircle2 className="w-5 h-5 text-green-500" />
                  Sans engagement
                </div>
                <div className="flex items-center gap-2">
                  <CheckCircle2 className="w-5 h-5 text-green-500" />
                  Conformité RGPD
                </div>
              </div>
            </div>

            {/* Right side - Visual */}
            <div className="relative">
              <div className="bg-white rounded-2xl shadow-2xl p-8 border border-gray-200">
                {/* Mock Dashboard */}
                <div className="space-y-4">
                  <div className="flex items-center justify-between">
                    <h3 className="text-lg font-bold text-gray-900">Tableau de bord</h3>
                    <span className="px-3 py-1 bg-green-100 text-green-700 rounded-full text-xs font-semibold">En direct</span>
                  </div>

                  <div className="grid grid-cols-2 gap-4">
                    {[
                      { label: 'Projets actifs', value: '12', color: 'blue' },
                      { label: 'Correspondances', value: '248', color: 'purple' },
                      { label: 'Compétences', value: '1,453', color: 'green' },
                      { label: 'Certifications RNCP', value: '9,374', color: 'orange' }
                    ].map((stat, i) => (
                      <div key={i} className="bg-gradient-to-br from-gray-50 to-gray-100 rounded-lg p-4">
                        <div className="text-2xl font-bold text-gray-900">{stat.value}</div>
                        <div className="text-xs text-gray-600 mt-1">{stat.label}</div>
                      </div>
                    ))}
                  </div>

                  <div className="h-48 bg-gradient-to-br from-blue-100 to-purple-100 rounded-lg flex items-center justify-center">
                    <BarChart3 className="w-20 h-20 text-blue-600 opacity-50" />
                  </div>
                </div>
              </div>

              {/* Floating badges */}
              <div className="absolute -top-4 -right-4 bg-white rounded-xl shadow-lg p-4 border border-gray-200 animate-float">
                <div className="flex items-center gap-2">
                  <TrendingUp className="w-6 h-6 text-green-500" />
                  <div>
                    <div className="text-xs text-gray-600">Temps économisé</div>
                    <div className="text-lg font-bold text-gray-900">70%</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ============ FEATURES SECTION ============ */}
      <section id="features" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
              Tout ce dont vous avez besoin
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Une plateforme complète pour analyser, visualiser et optimiser vos formations RNCP
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {features.map((feature, index) => (
              <div
                key={index}
                className="group bg-white border-2 border-gray-200 rounded-2xl p-8 hover:border-blue-500 hover:shadow-xl transition-all duration-300"
              >
                <div className={`inline-flex p-4 rounded-xl bg-gradient-to-r ${feature.color} text-white mb-6 group-hover:scale-110 transition-transform`}>
                  {feature.icon}
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">{feature.title}</h3>
                <p className="text-gray-600 leading-relaxed">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ============ ECOSYSTEM SECTION ============ */}
      <section className="py-20 bg-gradient-to-br from-blue-50 to-purple-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
              Connecté à l'écosystème officiel
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Synchronisation automatique avec les sources de données officielles françaises
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {ecosystem.map((item, index) => (
              <div
                key={index}
                className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition text-center"
              >
                <div className="text-5xl mb-4">{item.logo}</div>
                <h3 className="text-lg font-bold text-gray-900 mb-2">{item.title}</h3>
                <p className="text-sm text-gray-600">{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ============ HOW IT WORKS SECTION ============ */}
      <section id="how-it-works" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
              Comment ça fonctionne ?
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              4 étapes simples pour transformer votre pilotage pédagogique
            </p>
          </div>

          <div className="space-y-16">
            {steps.map((step, index) => (
              <div
                key={index}
                className={`flex flex-col ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} gap-12 items-center`}
              >
                <div className="flex-1">
                  <div className="inline-block px-4 py-2 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-full font-bold text-lg mb-4">
                    {step.number}
                  </div>
                  <h3 className="text-3xl font-bold text-gray-900 mb-4">{step.title}</h3>
                  <p className="text-lg text-gray-600 leading-relaxed">{step.description}</p>
                </div>

                <div className="flex-1 flex items-center justify-center">
                  <div className="w-64 h-64 bg-gradient-to-br from-blue-100 to-purple-100 rounded-2xl flex items-center justify-center shadow-xl">
                    <div className="text-blue-600">
                      {step.icon}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ============ PRICING SECTION ============ */}
      <section id="pricing" className="py-20 bg-gradient-to-br from-blue-50 to-purple-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
              Des tarifs adaptés à vos besoins
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Commencez gratuitement, évoluez selon vos besoins
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
            {/* Plan Gratuit */}
            <div className="bg-white rounded-2xl shadow-lg border-2 border-gray-200 p-8">
              <h3 className="text-2xl font-bold text-gray-900 mb-2">Gratuit</h3>
              <p className="text-gray-600 mb-6">Pour découvrir</p>
              <div className="mb-6">
                <div className="text-5xl font-bold text-gray-900">0€</div>
                <div className="text-gray-600">/mois</div>
              </div>
              <button
                onClick={() => navigate('/register')}
                className="w-full py-3 px-4 bg-gray-100 text-gray-900 rounded-lg font-semibold hover:bg-gray-200 transition mb-6"
              >
                Commencer gratuitement
              </button>
              <ul className="space-y-3">
                {[
                  'Visualiser 2 formations',
                  'Fusionner 2 formations',
                  'Analyse basique',
                  'Visualisation simple',
                  'Support email'
                ].map((feature, i) => (
                  <li key={i} className="flex items-start gap-2">
                    <CheckCircle2 className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" />
                    <span className="text-gray-700">{feature}</span>
                  </li>
                ))}
              </ul>
            </div>

            {/* Plan Starter */}
            <div className="bg-white rounded-2xl shadow-lg border-2 border-gray-200 p-8">
              <h3 className="text-2xl font-bold text-gray-900 mb-2">Starter</h3>
              <p className="text-gray-600 mb-6">Pour les petits OF</p>
              <div className="mb-6">
                <div className="text-5xl font-bold text-gray-900">29€</div>
                <div className="text-gray-600">/mois</div>
              </div>
              <button
                onClick={() => navigate('/register')}
                className="w-full py-3 px-4 bg-blue-600 text-white rounded-lg font-semibold hover:bg-blue-700 transition mb-6"
              >
                S'inscrire
              </button>
              <ul className="space-y-3">
                {[
                  '50 formations maximum',
                  'Analyse avancée',
                  'Visualisation interactive D3.js',
                  'Export CSV + JSON',
                  'Analyse ROI',
                  'Support prioritaire'
                ].map((feature, i) => (
                  <li key={i} className="flex items-start gap-2">
                    <CheckCircle2 className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" />
                    <span className="text-gray-700">{feature}</span>
                  </li>
                ))}
              </ul>
            </div>

            {/* Plan Pro */}
            <div className="bg-gradient-to-br from-blue-600 to-purple-600 rounded-2xl shadow-xl border-2 border-blue-600 p-8 text-white relative transform scale-105">
              <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                <span className="inline-flex items-center px-4 py-1 rounded-full text-sm font-semibold bg-orange-500 text-white shadow-lg">
                  Populaire
                </span>
              </div>
              <h3 className="text-2xl font-bold mb-2">Pro</h3>
              <p className="text-blue-100 mb-6">Pour les OF en croissance</p>
              <div className="mb-6">
                <div className="text-5xl font-bold">99€</div>
                <div className="text-blue-100">/mois</div>
              </div>
              <button
                onClick={() => navigate('/register')}
                className="w-full py-3 px-4 bg-white text-blue-600 rounded-lg font-semibold hover:bg-gray-100 transition mb-6"
              >
                S'inscrire
              </button>
              <ul className="space-y-3">
                {[
                  'Formations illimitées',
                  'Analyse avancée + IA',
                  'Export multi-formats (PDF)',
                  'Analyse ROI + benchmarks',
                  'Support prioritaire + chat',
                  'API access (10k requêtes/mois)',
                  'Multi-utilisateurs'
                ].map((feature, i) => (
                  <li key={i} className="flex items-start gap-2">
                    <CheckCircle2 className="w-5 h-5 text-green-300 flex-shrink-0 mt-0.5" />
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="text-center mt-12">
            <p className="text-gray-600 mb-4">
              💰 <strong>Réduction de 30%</strong> pour les associations à but non lucratif
            </p>
            <a href="#contact" className="text-blue-600 hover:text-blue-700 font-semibold">
              Contactez-nous pour en savoir plus →
            </a>
          </div>
        </div>
      </section>

      {/* ============ TESTIMONIALS SECTION ============ */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
              Ils nous font confiance
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Découvrez ce que nos clients disent d'Orbloom
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {testimonials.map((testimonial, index) => (
              <div
                key={index}
                className="bg-gradient-to-br from-gray-50 to-white rounded-2xl p-8 shadow-lg border border-gray-200 relative"
              >
                <Quote className="absolute top-6 right-6 w-12 h-12 text-blue-200" />

                <div className="flex items-center gap-1 mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" />
                  ))}
                </div>

                <p className="text-gray-700 mb-6 leading-relaxed italic">
                  "{testimonial.text}"
                </p>

                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 bg-gradient-to-br from-blue-600 to-purple-600 rounded-full flex items-center justify-center text-white font-bold">
                    {testimonial.avatar}
                  </div>
                  <div>
                    <div className="font-bold text-gray-900">{testimonial.name}</div>
                    <div className="text-sm text-gray-600">{testimonial.role}</div>
                    <div className="text-xs text-gray-500">{testimonial.company}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ============ FAQ SECTION ============ */}
      <section id="faq" className="py-20 bg-gradient-to-br from-blue-50 to-purple-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
              Questions fréquentes
            </h2>
            <p className="text-xl text-gray-600">
              Tout ce que vous devez savoir sur Orbloom
            </p>
          </div>

          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className="bg-white rounded-xl shadow-lg border border-gray-200 overflow-hidden"
              >
                <button
                  onClick={() => setActiveFaq(activeFaq === index ? null : index)}
                  className="w-full flex items-center justify-between p-6 text-left hover:bg-gray-50 transition"
                >
                  <span className="font-semibold text-gray-900 text-lg">{faq.question}</span>
                  <ChevronDown
                    className={`w-6 h-6 text-gray-600 transition-transform ${
                      activeFaq === index ? 'rotate-180' : ''
                    }`}
                  />
                </button>
                {activeFaq === index && (
                  <div className="px-6 pb-6">
                    <p className="text-gray-600 leading-relaxed">{faq.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ============ CONTACT SECTION ============ */}
      <section id="contact" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
              Contactez-nous
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Une question ? Notre équipe vous répond sous 24h
            </p>
          </div>

          <div className="grid lg:grid-cols-2 gap-12">
            {/* Contact Info */}
            <div className="space-y-8">
              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-6">
                  Nos coordonnées
                </h3>
                <div className="space-y-4">
                  <div className="flex items-start gap-4">
                    <div className="p-3 bg-blue-100 rounded-lg">
                      <Mail className="w-6 h-6 text-blue-600" />
                    </div>
                    <div>
                      <div className="font-semibold text-gray-900">Email</div>
                      <a href="mailto:contact@orbloom.fr" className="text-blue-600 hover:underline">
                        contact@orbloom.fr
                      </a>
                    </div>
                  </div>

                  <div className="flex items-start gap-4">
                    <div className="p-3 bg-green-100 rounded-lg">
                      <Phone className="w-6 h-6 text-green-600" />
                    </div>
                    <div>
                      <div className="font-semibold text-gray-900">Téléphone</div>
                      <a href="tel:+33123456789" className="text-blue-600 hover:underline">
                        +33 1 23 45 67 89
                      </a>
                    </div>
                  </div>

                  <div className="flex items-start gap-4">
                    <div className="p-3 bg-purple-100 rounded-lg">
                      <MapPin className="w-6 h-6 text-purple-600" />
                    </div>
                    <div>
                      <div className="font-semibold text-gray-900">Adresse</div>
                      <p className="text-gray-600">
                        123 Rue de la Formation<br />
                        75001 Paris, France
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-gradient-to-br from-blue-50 to-purple-50 rounded-xl p-6">
                <h4 className="font-bold text-gray-900 mb-2">Support technique</h4>
                <p className="text-gray-600 text-sm mb-4">
                  Pour toute question technique, consultez notre centre d'aide ou contactez notre support.
                </p>
                <button
                  onClick={() => navigate('/knowledge-base')}
                  className="text-blue-600 hover:text-blue-700 font-semibold text-sm"
                >
                  Accéder au centre d'aide →
                </button>
              </div>
            </div>

            {/* Contact Form */}
            <div className="bg-white rounded-2xl shadow-xl border border-gray-200 p-8">
              {contactSubmitted ? (
                // Bloc de confirmation avec animation Lottie
                <div className="text-center py-8">
                  <div className="flex justify-center mb-6">
                    <Lottie
                      animationData={emailSentAnimation}
                      loop={true}
                      style={{ width: 180, height: 180 }}
                    />
                  </div>
                  <h3 className="text-3xl font-bold text-gray-900 mb-4">
                    Message envoyé !
                  </h3>
                  <p className="text-lg text-gray-600 mb-6 max-w-md mx-auto">
                    Merci pour votre message. Notre équipe vous répondra sous <strong>24h</strong>.
                  </p>
                  <p className="text-sm text-gray-500 mb-8">
                    Un email de confirmation a été envoyé à votre adresse.
                  </p>
                  <button
                    onClick={() => setContactSubmitted(false)}
                    className="inline-flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-lg font-semibold hover:from-blue-700 hover:to-purple-700 transition shadow-lg"
                  >
                    <Send className="w-5 h-5" />
                    Envoyer un autre message
                  </button>
                </div>
              ) : (
                // Formulaire de contact
                <>
                  <h3 className="text-2xl font-bold text-gray-900 mb-6">
                    Envoyez-nous un message
                  </h3>
                  <form onSubmit={handleContactSubmit} className="space-y-6">
                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-2">
                        Nom complet
                      </label>
                      <input
                        type="text"
                        required
                        value={contactForm.name}
                        onChange={(e) => setContactForm({ ...contactForm, name: e.target.value })}
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        placeholder="Jean Dupont"
                        disabled={contactLoading}
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-2">
                        Email
                      </label>
                      <input
                        type="email"
                        required
                        value={contactForm.email}
                        onChange={(e) => setContactForm({ ...contactForm, email: e.target.value })}
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        placeholder="jean.dupont@example.com"
                        disabled={contactLoading}
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-2">
                        Organisme
                      </label>
                      <input
                        type="text"
                        value={contactForm.company}
                        onChange={(e) => setContactForm({ ...contactForm, company: e.target.value })}
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        placeholder="Mon organisme de formation"
                        disabled={contactLoading}
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-2">
                        Message
                      </label>
                      <textarea
                        required
                        rows={5}
                        value={contactForm.message}
                        onChange={(e) => setContactForm({ ...contactForm, message: e.target.value })}
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        placeholder="Votre message..."
                        disabled={contactLoading}
                      ></textarea>
                    </div>

                    <button
                      type="submit"
                      disabled={contactLoading}
                      className="w-full inline-flex items-center justify-center gap-2 px-6 py-4 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-lg font-semibold hover:from-blue-700 hover:to-purple-700 transition shadow-lg hover:shadow-xl disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                      {contactLoading ? (
                        <>
                          <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>
                          Envoi en cours...
                        </>
                      ) : (
                        <>
                          <Send className="w-5 h-5" />
                          Envoyer le message
                        </>
                      )}
                    </button>
                  </form>
                </>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* ============ NEWSLETTER ============ */}
      <section className="py-16 bg-gradient-to-br from-blue-600 via-purple-600 to-pink-600">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="bg-white/10 backdrop-blur-lg rounded-2xl p-8 md:p-12 border border-white/20">
            <Mail className="w-16 h-16 text-white mx-auto mb-6" />
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
              Restez informé des nouveautés
            </h2>
            <p className="text-lg text-white/90 mb-8 max-w-2xl mx-auto">
              Inscrivez-vous à notre newsletter pour recevoir les dernières actualités,
              mises à jour produit et conseils d'optimisation pédagogique.
            </p>

            <form
              onSubmit={async (e) => {
                e.preventDefault();

                if (!newsletterEmail || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(newsletterEmail)) {
                  toast.error('Veuillez entrer une adresse email valide');
                  return;
                }

                setNewsletterLoading(true);

                try {
                  const response = await fetch(`${import.meta.env.VITE_API_URL}/newsletter/subscribe`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ email: newsletterEmail })
                  });

                  const data = await response.json();

                  if (data.success) {
                    toast.success('Inscription réussie ! Vérifiez votre boîte email.');
                    setNewsletterEmail('');
                  } else {
                    toast.error(data.message || 'Erreur lors de l\'inscription');
                  }
                } catch (error) {
                  toast.error('Erreur de connexion au serveur');
                } finally {
                  setNewsletterLoading(false);
                }
              }}
              className="flex flex-col sm:flex-row gap-4 max-w-xl mx-auto"
            >
              <input
                type="email"
                value={newsletterEmail}
                onChange={(e) => setNewsletterEmail(e.target.value)}
                placeholder="votre@email.com"
                className="flex-1 px-6 py-4 rounded-full text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-4 focus:ring-white/30 transition-all"
                disabled={newsletterLoading}
              />
              <button
                type="submit"
                disabled={newsletterLoading}
                className="px-8 py-4 bg-white text-purple-600 rounded-full font-semibold hover:bg-gray-100 focus:outline-none focus:ring-4 focus:ring-white/30 transition-all disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
              >
                {newsletterLoading ? (
                  <>
                    <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-purple-600"></div>
                    Inscription...
                  </>
                ) : (
                  <>
                    <Send className="w-5 h-5" />
                    S'inscrire
                  </>
                )}
              </button>
            </form>

            <p className="text-white/70 text-sm mt-6">
              Pas de spam. Désinscription en un clic. Vos données sont protégées (RGPD).
            </p>
          </div>
        </div>
      </section>

      {/* ============ FOOTER ============ */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-4 gap-8 mb-8">
            {/* Logo & Description */}
            <div className="md:col-span-2">
              <div className="flex items-center gap-2 mb-4">
                <div className="w-10 h-10 bg-gradient-to-br from-blue-600 to-purple-600 rounded-lg flex items-center justify-center">
                  <Target className="w-6 h-6 text-white" />
                </div>
                <span className="text-xl font-bold">Orbloom</span>
              </div>
              <p className="text-gray-400 mb-4">
                La plateforme #1 de pilotage pédagogique RNCP. Analysez, visualisez et optimisez vos formations en toute simplicité.
              </p>
              <div className="flex items-center gap-2 text-sm text-gray-400">
                <Shield className="w-4 h-4" />
                100% conforme RGPD • Hébergement France
              </div>
            </div>

            {/* Links */}
            <div>
              <h4 className="font-bold mb-4">Produit</h4>
              <ul className="space-y-2 text-gray-400">
                <li><a href="#features" className="hover:text-white transition">Fonctionnalités</a></li>
                <li><a href="#pricing" className="hover:text-white transition">Tarifs</a></li>
                <li><a href="#" onClick={() => navigate('/knowledge-base')} className="hover:text-white transition">Centre d'aide</a></li>
                <li><a href="#" className="hover:text-white transition">Documentation</a></li>
              </ul>
            </div>

            {/* Legal */}
            <div>
              <h4 className="font-bold mb-4">Légal</h4>
              <ul className="space-y-2 text-gray-400">
                <li><a href="#" onClick={() => navigate('/privacy-policy')} className="hover:text-white transition">Confidentialité</a></li>
                <li><a href="#" className="hover:text-white transition">CGU</a></li>
                <li><a href="#" className="hover:text-white transition">Mentions légales</a></li>
                <li><a href="#contact" className="hover:text-white transition">Contact</a></li>
              </ul>
            </div>
          </div>

          <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row items-center justify-between">
            <p className="text-gray-400 text-sm">
              © 2025 Orbloom. Tous droits réservés.
            </p>
            <div className="flex items-center gap-6 mt-4 md:mt-0">
              <a href="#" className="text-gray-400 hover:text-white transition">LinkedIn</a>
              <a href="#" className="text-gray-400 hover:text-white transition">GitHub</a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
